const fontAwesomeLink = document.createElement("link");
const sa = document.createElement("script");
(sa.type = "text/javascript"), (sa.src = "https://cdn.jsdelivr.net/npm/sweetalert2@11"), document.head.appendChild(sa);


const queryString = window.location.search,
    urlParams = new URLSearchParams(queryString),
    hasOrderProcessingParam = urlParams.get("order-processing"),
    hasEuCoIdParam = urlParams.get("EuCoId");

function saveUTMToLocalStorage() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    // Create an empty object to store UTM parameters
    const utm = {};

    // Define the UTM parameters and their corresponding keys
    const utmParams = {
        "utm_medium": "utm_medium",
        "utm_source": "utm_source",
        "utm_campaign": "utm_campaign",
        "utm_term": "utm_term",
        "utm_content": "utm_content",
        "ad_id": "ad_id",
        "ttclid": "ttclid",
        "fbclid": "fbclid",

    };


    for (const [paramName, key] of Object.entries(utmParams)) {
        const paramValue = urlParams.get(paramName);
        if (paramValue) {
            utm[key] = paramValue;
        }
    }

    // Check if utm parameters exist in localStorage
    const existingUTM = localStorage.getItem("utm");
    // Check if utm object is not empty
    if (Object.keys(utm).length > 0 && !existingUTM) {
        localStorage.setItem("utm", JSON.stringify(utm));
    }
}

// Call the function to save UTM parameters to localStorage
saveUTMToLocalStorage();


function setId() {
    localStorage.EuCoId = hasEuCoIdParam;
}
if (hasOrderProcessingParam && hasEuCoIdParam) {

    async function rc() {
        const url = "/cart/clear.js";
        try {
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            const json = await response.json();

        } catch (error) {
            console.error("Error clearing the cart:", error.message);
        }
    }
    (async () => {
        await rc();
    })();



    localStorage.removeItem("utm");
    function getId() {
        (document.cookie = "cart=;expires=2021-12-19T15:12:13.000Z")
        return localStorage.getItem("EuCoId");
    }
    setId(),
        document.addEventListener("DOMContentLoaded", function () {
            function addStylesAndScripts() {
                if (!document.querySelector("#custom-loader-css")) {
                    const style = document.createElement("style");
                    style.id = "custom-loader-css";
                    style.textContent = `
                html, body {
                    height: 100%;
                    margin: 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .loader {
                    width: 60px;
                    height: 60px;
                    border: 5px solid black;
                    border-bottom-color: transparent;
                    border-radius: 50%;
                    display: inline-block;
                    box-sizing: border-box;
                    animation: rotation 1s linear infinite;
                }

                @keyframes rotation {
                    0% {
                        transform: rotate(0deg);
                    }
                    100% {
                        transform: rotate(360deg);
                    }
                }

                .full-screen-center {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    height: 100%;
                    width: 100%;
                }
            `;
                    document.head.appendChild(style);
                }
            }

            function addProcessingDiv() {
                // Create a div element with inline styles for flexbox
                var div = document.createElement('div');
                div.className = "full-screen-center";
                div.style.display = "flex";
                div.style.flexDirection = "column-reverse";


                // Create p element for the text
                var p = document.createElement('p');
                p.className = "italic";
                p.textContent = "Loading...";
                p.style.marginBottom = "20px";


                var span = document.createElement('span');
                span.className = "";

                div.appendChild(p);
                div.appendChild(span);


                document.body.innerHTML = "<img src='https://i.ibb.co.com/F6ZPNzM/Rolling-0-5s-193px.gif' width='50'>";
                document.body.appendChild(div);
            }


            addStylesAndScripts();
            addProcessingDiv();
        });





    (async () => {
        const TIMEOUT_MS = 20000; // Timeout for each fetch request
        const RETRY_DELAY_MS = 3000; // Delay between retries
        const MAX_RETRIES = 3; // Maximum number of retries (3)
        const GLOBAL_TIMEOUT_MS = 20000; // Global timeout for the whole process (20 seconds)

        try {
            // Function to fetch order success data with a timeout
            const fetchOrderSuccess = async () => {
                const response = await Promise.race([
                    fetch(`https://${subdomain()}.${server()}/api/v1/order-process/${getId()}`),
                    new Promise((_, reject) => setTimeout(() => reject(new Error('Timeout')), TIMEOUT_MS)) // Timeout for each fetch
                ]);
                return await response.json();
            };

            let orderSuccessResponse;
            let retryCount = 0;

            // Start the global timeout
            const globalTimeout = new Promise((_, reject) => setTimeout(() => reject(new Error('Global timeout exceeded')), GLOBAL_TIMEOUT_MS));

            // Retry loop with a maximum limit of 3 retries
            while (retryCount < MAX_RETRIES) {
                try {
                    // Use Promise.race to run fetch with the global timeout
                    orderSuccessResponse = await Promise.race([fetchOrderSuccess(), globalTimeout]);
                    if (orderSuccessResponse) {
                        break; // Exit the loop if a response is received
                    }
                } catch (error) {
                    console.error(`Attempt ${retryCount + 1}: Error fetching order success data:`, error.message);
                }

                retryCount++;
                await new Promise(resolve => setTimeout(resolve, RETRY_DELAY_MS)); // Wait before retrying
            }

            // If retries exhausted or global timeout exceeded, reload the page
            if (!orderSuccessResponse) {
                console.warn('Max retries reached or global timeout exceeded. Reloading the page.');
                window.location.reload(); // Reload the page after max retries or global timeout
                return;
            }

            // Handle successful response
            if (orderSuccessResponse?.typl) {
                window.location.href = orderSuccessResponse.typl;
            } else if (orderSuccessResponse?.message) {
                document.body.innerHTML = `<p>${orderSuccessResponse.message}</p>`;
            } else {
                document.body.innerHTML = '<p>Something went wrong. Please try again later.</p>';
            }

            // Reload the page after 20 seconds regardless of success
            setTimeout(() => {
                window.location.reload();
            }, 20000);

        } catch (error) {
            console.error('An unexpected error occurred:', error);
            document.body.innerHTML = `<p>An unexpected error occurred: ${error.message}</p>`;

            // Reload the page after a delay in case of an unexpected error
            setTimeout(() => {
                window.location.reload();
            }, 10000);
        }
    })();



}
let intervalID;
async function stripe_checkout(e) {
    let str = window.Shopify.shop;
    let utmGet = localStorage.getItem('utm');
    intervalID = null;
    try {
        let n = window.location.origin;
        let o = await fetch(`${n}/cart.js`);
        let s = await o.json();
        // ipresponse = await fetch("https://get.geojs.io/v1/ip/geo.json");
        // ip = await ipresponse.json();
        // s.country = ip?.country_code;

        s.country = typeof getGeo === "function" ? await getGeo() : "";
        s.utm = JSON.parse(utmGet);
        s.str = str || "";

        let a = await fetch(`https://${subdomain()}.${server()}/api/v1/checkout/payment`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(s)
        });

        let r = await a.json();

        if (r.type) {
            e.disabled = false;
            e.innerText = "Reload & Try Again...";
            var t = document.createElement("p");
            t.id = "errorMessage";
            t.style.color = "red";
            t.style.display = "block";
            e.parentNode.insertAdjacentElement("afterend", t);
            document.getElementById("errorMessage").innerText = `${r?.raw?.message.split("(", 1)}`;

            Swal.fire({
                icon: "error",
                title: "Error...",
                color: "red",
                confirmButtonColor: "#3085d6",
                text: `${r?.raw?.message.split("(", 1)}` || "Something Went Wrong...",
                allowOutsideClick: false,
                confirmButtonText: 'OK'
            }).then((result) => {
                if (result.isConfirmed) {
                    window.location.reload(); // Reload the page
                }
            });

            console.log(r?.raw?.message);
        } else {
            window.location.href = r.url;
        }
    } catch (t) {
        console.log(t);
        e.innerText = "Reload & Try Again...";
        e.disabled = true;
    }

}

intervalID = setInterval(function () {
    function removeScriptsWithDataAttribute() {
        const scriptTags = document.querySelectorAll('script[data-checkify-url]');

        scriptTags?.forEach(script => {
            script.parentNode.removeChild(script);
        });
    }

    removeScriptsWithDataAttribute();

    if (!document.querySelector("#custom-loader-css")) {
        const style = document.createElement("style");
        style.id = "custom-loader-css";
        style.textContent = `
        .loader {
            width: 20px;
            height: 20px;
            border: 2px solid white;
            border-bottom-color: transparent;
            border-radius: 50%;
            display: inline-block;
            box-sizing: border-box;
            animation: rotation 1s linear infinite;
        }

        @keyframes rotation {
            0% {
                transform: rotate(0deg);
            }
            100% {
                transform: rotate(360deg);
            }
        }
    `;
        document.head.appendChild(style);
    };

    const checkoutButtons = document.querySelectorAll('.upcart-checkout-button');
    checkoutButtons.forEach((checkoutButton) => {
        const newDiv = document.createElement('div');
        newDiv.setAttribute('sc', 'checkout');
        newDiv.className = 'styles_Button__fullWidth__uCmBU';
        newDiv.style.width = '100%';
        newDiv.style.backgroundColor = 'black';
        newDiv.style.color = 'white';
        newDiv.innerHTML = checkoutButton.innerHTML;
        checkoutButton.parentNode.replaceChild(newDiv, checkoutButton);
    });

    const elements = document.querySelectorAll(' .slide-cart-checkout-btn, [name="checkout"], [id="checkout"], [id="CartDrawer-Checkout"], [form="CartDrawer-Form"], a[href="/checkout"], a[href="checkout"], a[href="/checkout/"], a[href="checkout/"], [sc="checkout"], button[sc="checkout"], a[sc="checkout"]', '[id="cart-checkout"]', '[data-href="/checkout"]');
    elements?.forEach((element) => {
        element?.removeAttribute("name");
        element?.removeAttribute("id");
        element?.removeAttribute("type");
        element?.removeAttribute("data-href");
        element?.setAttribute("sc", "checkout");


        element?.addEventListener("click", function (event) {
            event.preventDefault();
            element.disabled = true;

  
    element.innerHTML = "<img src='https://i.ibb.co.com/F6ZPNzM/Rolling-0-5s-193px.gif' width='30'>";

  

            if (intervalID) {
                stripe_checkout(element);
            }
        });
    });
}, 100);



function subdomain() {
    let url = "elvante";
    return url
}
function server() { let server = "abcheckout.com"; return server; }

document.addEventListener('contextmenu', function (e) {
    e.preventDefault();
});

document.addEventListener('keydown', function (e) {
    if (e.key === 'F12') {
        e.preventDefault();
    }
});






                                var css = 'div[data-shopify="payment-button"]{ display: none !important; } div[data-shopify="dynamic-checkout-cart"]{ display: none !important; }'
                                var style = document.createElement('style');
                                style.type = 'text/css';
                                if (style.styleSheet) {
                                    style.styleSheet.cssText = css;
                                } else {
                                    style.appendChild(document.createTextNode(css));
                                }
                                document.head.appendChild(style);
                            